<template>
  <div class="renouvellement-history">
    <!-- Loading alert -->
    <b-alert :model-value="loading" class="mt-3 rounded" variant="info" show>
      <b-spinner small label="Small Spinner"></b-spinner>
      <span class="ms-2">Chargement de la liste des renouvellements...</span>
    </b-alert>

    <!-- TABLEAU AFFICHAGE -->
    <!-- Table Component -->
    <ParcProfileParcCardRenouvellementListTable
      v-if="!loading && isRenouvellements"
      :renouvellements="renouvellements"
      :emptyField="emptyField"
      :isEditable="true"
      @edit-renouvellement="onEditRenouvellement"
    />

    <!-- No renouvellements alert -->
    <b-alert
      :model-value="true"
      class="mt-3 rounded"
      variant="warning"
      show
      v-else-if="!loading && !isRenouvellements"
    >
      <span class="ms-2">Aucun renouvellement n'est spécifié pour ce parc.</span>
    </b-alert>

    <!-- MODALE SUPPRESSION -->
    <renouvellement-delete-modal :updateParc="updateParc" />
    <!-- MODALE Modification -->
    <renouvellement-edit-modal
      ref="editModalRef"
      @reload-parc="$emit('reload-parc')"
      :updateParc="updateParc"
    />
  </div>
</template>
<script>
import ParcProfileParcCardRenouvellementListTable from '@/components/ParcProfileParcCardRenouvellementListTable.vue';
import { renouvellementService } from "@/service/renouvellement.service.js";
import { parcService } from "@/service/parc.service.js";
import { commonService } from "@/service/common.service.js";
import { mapGetters } from "vuex";
import {
  BAlert,
  BSpinner
} from "bootstrap-vue-next";
import RenouvellementDeleteModal from "@/components/Modals/RenouvellementDeleteModal.vue";
import RenouvellementEditModal from "@/components/Modals/RenouvellementEditModal.vue";

export default {
  name: 'ParcProfileParcCardRenouvellementList',
  components: {
    ParcProfileParcCardRenouvellementListTable,
    BAlert,
    BSpinner,
    RenouvellementDeleteModal,
    RenouvellementEditModal
  },

  data() {
    return {
      loading: false,
      emptyField: "-",
      editModalRef: null
    };
  },

  computed: {
    ...mapGetters({
      parc: 'parc',
      renouvellements: 'renouvellements',
      isRenouvellements: 'isRenouvellements'
    })
  },

  methods: {
    getRenouvellementsByParcId() {
      this.loading = true;

      renouvellementService
        .getRenouvellementsByParcId(this.parc.id)
        .then(data => {
          if (data) {
            this.$store.dispatch("saveRenouvellements", data);
          }
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },

    updateParc(parc) {
      parcService
        .putParc(parc)
        .then(response => {
          parcService.getParcById(parc.id).then(updatedParc => {
            this.$store.dispatch("saveParc", updatedParc);
          });

          commonService.handleAnyResponse(response);
        })
        .catch(err => {
          console.log(err);
        });
    },

    onEditRenouvellement(renouvellement) {
      this.$refs.editModalRef.prepareEdit(renouvellement);
    }
  },

  created() {
    this.getRenouvellementsByParcId();
  },

}
</script>

<style lang="scss">
.renouvellement-history {
  table > * {
    font-size: 0.9em !important;
    text-align: center;
  }

  .btn-cell {
    text-align: right;
    padding-right: 15px !important;
    padding-right: 23px !important;

    button {
      $x-padding: 16px;
      padding-right: $x-padding !important;
      padding-left: $x-padding !important;
    }
  }

  table {
    tr {
      td:last-of-type,
      th:last-of-type {
        padding-left: 59px;
      }
    }
  }
}

#modal-renouvellement-list {
  .modal-footer {
    button {
      margin-right: 27px;
    }
  }
}

#modal-edit-renouvellement {
  .form-control {
    border: #ced4da 1px solid;
  }
}
</style>
